
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Assessment } from '@/types/assessment';

interface OverviewTabProps {
  assessment: Assessment;
  responsesCount: number;
}

export function OverviewTab({ assessment, responsesCount }: OverviewTabProps) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Assessment Description</CardTitle>
        </CardHeader>
        <CardContent>
          <p>{assessment.description}</p>
        </CardContent>
      </Card>
      
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Categories
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{assessment.categories.length}</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Questions
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">
              {assessment.categories.reduce(
                (total, category) => total + category.questions.length, 0
              )}
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Responses
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{responsesCount}</div>
          </CardContent>
        </Card>
      </div>
      
      <Card>
        <CardHeader>
          <CardTitle>Categories</CardTitle>
          <CardDescription>
            Assessment categories and questions
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {assessment.categories.map((category) => (
              <div key={category.id} className="border rounded-lg p-4">
                <h3 className="font-semibold text-lg mb-1">{category.name}</h3>
                <p className="text-sm text-muted-foreground mb-4">
                  {category.description}
                </p>
                <h4 className="font-medium text-sm text-muted-foreground mb-3">
                  Questions ({category.questions.length})
                </h4>
                <ul className="space-y-2">
                  {category.questions.map((question, index) => (
                    <li key={question.id} className="text-sm">
                      <span className="font-medium mr-2">{index + 1}.</span>
                      {question.text}
                      <span className="ml-2 text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">
                        {question.answerType === 'single' && 'Single Choice'}
                        {question.answerType === 'multiple' && 'Multiple Choice'}
                        {question.answerType === 'slider' && 'Slider'}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
